import $ from "jquery";
import ko from "knockout";
import { registerKnockoutBinding } from "flow/knockout/register";

registerKnockoutBinding("clickOutside", {
    init: (element, valueAccessor) => {
        const func = ko.unwrap(valueAccessor());

        const callback = (e: JQuery.ClickEvent) => {
            if (!($.contains(element, e.target) || element === e.target)) {
                func();
            }
        };

        $(document).on("click", callback);

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            $(document).off("click", callback);
        });
    }
});
